import { InputNumber, Form, Row, Col } from "antd";

export default () => {
  return (
    <Form.Item label="Padding">
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="paddingTop">
            <InputNumber
              prefix="Top:"
              min={0}
              max={60}
              step={5}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="paddingRight">
            <InputNumber
              prefix="Right:"
              min={0}
              max={60}
              step={5}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="paddingBottom">
            <InputNumber
              prefix="Bottom:"
              min={0}
              max={60}
              step={5}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="paddingLeft">
            <InputNumber
              prefix="Left:"
              min={0}
              max={60}
              step={5}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form.Item>
  );
};
